export default __webpack_public_path__ + "static/media/gallery_17.12691110.jpg";